import type { Unref } from '@wix/thunderbolt-catharsis'
import type { ScopedCreateRef } from '../../../compNodeUtils'

export type TemplateDataNode<TDataItem, TDependencies, TData> = {
	getDependencies: (item: Readonly<TDataItem>, scopedCreateRef: ScopedCreateRef) => TDependencies
	toViewItem?: (data: Unref<TData>) => any
}

export const createTemplateDataNode = <TDataItem, TDependencies, TData>(
	obj: TemplateDataNode<TDataItem, TDependencies, TData>
) => obj

export const defaultDataNodeToViewItem = (rawItem: any, value: any) => {
	const { schema: refs, custom: dependencies } = value || {}

	if (!refs && !dependencies) {
		return rawItem
	}

	const result = { ...rawItem, ...refs, ...(dependencies && { dependencies }) }

	delete result.metaData
	return result
}
